import axios from "axios";
import { environment } from "../../../environments/environment";

export function getParts(filters, dropdownColumnMap, dropdownValueMap, page = 0, pageSize = 10, orderBy, search="") {
  let filterArray = [...Object.entries(filters?.dropdowns ?? {}).map(([dropdownId, values]) => ({
    "columnName": dropdownColumnMap[dropdownId],
    "value": values.map(dropdown => dropdown[dropdownValueMap[dropdownId]])
  })).filter(dropdown => dropdown?.value?.length > 0),
  ...Object.entries(filters?.txt ?? {}).filter(([columnName, value]) => Boolean(value)).map(([columnName, value]) => ({
    columnName,
    value
  }))
  ];
  return axios.post(`${environment.getParts}?page=${page}&pageSize=${pageSize}${orderBy ? `&orderBy=${orderBy}` : ''}&search=${search}`, [...(filterArray ?? [])], {
    headers: {
      "Content-Type": "application/json"
    }
  });

}



export function createPart(body) {
  let accountId = parseInt(localStorage.getItem('u_account_id'));
  let companyId = parseInt(localStorage.getItem('u_company_id'));
  body = isNaN(accountId) ? body : { ...body, accountId };
  body = isNaN(companyId) ? body : { ...body, companyId };

  return axios.request({
    method: body.id === null ? 'POST' : 'PUT',
    url: environment.createPart,
    data: body.id === null ? null : body
  })
}

// export async function nlaUpdate(partId, parentId, positions){
//   console.warn('*updating nla', partId, parentId, positions);
//   let response = await getPartInfo(partId);
//   if (response.data.responseCode === 200) {
//     // let response2 = await createPart({...response.data.load, positions, parentPartId:parentId});
//     let response2 = await axios.put(environment.createPart, {...response.data.load, parentPartId:parentId});
//     let response3 = await axios.post(environment.savePositions, positions);
//     return response3;
//   }
//   console.warn('*found part', response.data.load);
// }

export function removePart(partId) {
  return axios.delete(`${environment.deletePart}?partId=${partId}`)
}

// export function validateDropdownOption(dropdownId, columnValue, parameters) {
//   return axios.request({method: 'POST',url:`${environment.getDropdownEntity}?dropdownId=${dropdownId}&columnValue=${columnValue}`, data:parameters ?? []});

// }

export function validateDropdownOption(dropdownId, columnValue, parameters , selectedColumnName) {
  let body = Array.isArray(parameters) ? [...parameters] : [];

  if (columnValue !== undefined && columnValue !== null) {
    body.push({
      columnName: selectedColumnName,
      value: Array.isArray(columnValue) ? columnValue : [columnValue]
    });
  }

  return axios.request({
    method: 'POST',
    url: `${environment.getDropdownEntity}?dropdownId=${dropdownId}&columnValue=${columnValue ?? ''}`,
    data: body
  });
}




export function getPartInfo(partId) {
  return axios.get(environment.getPartConfigurationInfo + '?partId=' + partId, { hideLoader: true })
}

export function getDropdownConfiguration(dropdownId) {
  return axios.get(`${environment.getDropDownConfig}dropdownId=${dropdownId}`, { hideLoader: true })
}